import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { SemovelProvider } from '../../providers/semovel/semovel';
import { ReceitaViewPage } from '../receita-view/receita-view';

@Component({
  selector: 'page-receita-list',
  templateUrl: 'receita-list.html',
})
export class ReceitaListPage {

  receitas: Array<any>;

  range = 0;

  constructor(public navCtrl: NavController, public navParams: NavParams, private server:SemovelProvider ) {
  }

  ionViewDidLoad() {
    this.receitas = [];
    this.range = 0;

    this.carregarDados();
  }

  carregarDados(){
    let request = { method: 'receitas' };

    this.server.postData(request, {range:this.range}).subscribe(data => {
      if (data) 
        this.loadList(data);
        return true;
    },
    error => {
      this.server.showError(error);          
    });
  }

  loadList(receitas) {
    for(var i in receitas) {       
      let dado = receitas[i];
      dado.url_imagem = this.server.imagens + dado.imagem;
      console.log(dado);
      this.receitas.push(dado);
      this.range ++;
    }
  }

  buscarReceita(idReceita){
    let request = { method: 'visualizar_receita' };
    this.server.postData(request, {receita_id:idReceita}).subscribe(data => {
      if (data) {
        this.abrirReceita(data);
      }
      return true;
    },
    error => {
      this.server.showError(error);          
    });
  }

  abrirReceita(receita){
    receita.url_imagem = this.server.imagens + receita.imagem;
    this.navCtrl.push(ReceitaViewPage, {
      receita: receita
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/receita-list/receita-list.ts